import { normalizeStyle as _normalizeStyle, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, createVNode as _createVNode, createElementBlock as _createElementBlock, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, resolveDirective as _resolveDirective, withDirectives as _withDirectives, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@assets/img/logo/logo.svg'
import _imports_1 from '@assets/img/Icons/close--button.svg'
import _imports_2 from '@assets/img/Icons/header/notification.svg'
import _imports_3 from '@assets/img/Icons/header/log-out.svg'


const _withScopeId = (n: any) => (_pushScopeId("data-v-60f1a13f"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "left-block" }
const _hoisted_2 = { class: "logo" }
const _hoisted_3 = {
  key: 0,
  class: "right-block"
}
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_1,
  alt: ""
}, null, -1))
const _hoisted_5 = {
  key: 1,
  class: "right-block"
}
const _hoisted_6 = {
  class: "header__user-block notification",
  style: { marginRight: `10px` }
}
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_2,
  alt: ""
}, null, -1))
const _hoisted_8 = {
  key: 0,
  class: "notification_popup"
}
const _hoisted_9 = { class: "notification_wrapper" }
const _hoisted_10 = { key: 0 }
const _hoisted_11 = { key: 0 }
const _hoisted_12 = { class: "action_name" }
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "action_sum" }, "+ 500 €", -1))
const _hoisted_14 = {
  key: 1,
  class: "action_name text"
}
const _hoisted_15 = { key: 1 }
const _hoisted_16 = { class: "action_field" }
const _hoisted_17 = { class: "action_name text" }
const _hoisted_18 = { class: "header__user-block" }
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", { src: _imports_3 }, null, -1))
const _hoisted_20 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "gradient-fon" }, null, -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_header_menu_hamburger = _resolveComponent("header-menu-hamburger")!
  const _component_ui_button = _resolveComponent("ui-button")!
  const _directive_click_outside = _resolveDirective("click-outside")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("header", {
      class: "header",
      style: _normalizeStyle({ height: _ctx.$route.name === _ctx.UserIdentification ? `93px` : `100px` })
    }, [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("span", {
            class: "v-norme-button",
            onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.goToMainPage && _ctx.goToMainPage(...args)))
          }, [
            _createElementVNode("div", null, [
              _createElementVNode("img", {
                src: _imports_0,
                alt: "",
                style: _normalizeStyle({
						width: _ctx.$route.name === _ctx.UserIdentification ? `206px` : `206px`,
					})
              }, null, 4)
            ])
          ])
        ]),
        (_ctx.isShowBurger())
          ? (_openBlock(), _createBlock(_component_header_menu_hamburger, {
              key: 0,
              onOnClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.onClickMenu($event))),
              active: _ctx.show
            }, null, 8, ["active"]))
          : _createCommentVNode("", true)
      ]),
      (_ctx.isLogin)
        ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
            _createVNode(_component_ui_button, {
              class: "header_button",
              onClick: _ctx.onClose
            }, {
              default: _withCtx(() => [
                _hoisted_4
              ]),
              _: 1
            }, 8, ["onClick"])
          ]))
        : (_openBlock(), _createElementBlock("div", _hoisted_5, [
            _createElementVNode("div", _hoisted_6, [
              _createVNode(_component_ui_button, {
                class: "header_button noty",
                onClick: _ctx.openNotificationPopup
              }, {
                default: _withCtx(() => [
                  _hoisted_7
                ]),
                _: 1
              }, 8, ["onClick"]),
              (_ctx.isOpenNotificationPopup)
                ? _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_8, [
                    _createElementVNode("div", _hoisted_9, [
                      (_ctx.SystemMessages.length > 0)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
                            _createElementVNode("div", null, [
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.SystemMessages, (message, index) => {
                                return (_openBlock(), _createElementBlock("div", {
                                  class: "action_field",
                                  key: index
                                }, [
                                  (message.TypeSystemMessageId === 3)
                                    ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
                                        _createElementVNode("p", _hoisted_12, _toDisplayString(_ctx.$localization.getTranslate(
												"TheCardHasBeenSuccessfullyReplenished"
											)) + " (5412 •••• •••• 8713) ", 1),
                                        _hoisted_13
                                      ]))
                                    : (_openBlock(), _createElementBlock("p", _hoisted_14, _toDisplayString(message.Text), 1))
                                ]))
                              }), 128))
                            ])
                          ]))
                        : (_openBlock(), _createElementBlock("div", _hoisted_15, [
                            _createElementVNode("div", _hoisted_16, [
                              _createElementVNode("p", _hoisted_17, _toDisplayString(_ctx.$localization.getTranslate("NoNotifications")), 1)
                            ])
                          ]))
                    ])
                  ])), [
                    [_directive_click_outside, _ctx.closeNotificationPopup]
                  ])
                : _createCommentVNode("", true)
            ]),
            _createElementVNode("div", _hoisted_18, [
              _createVNode(_component_ui_button, {
                class: "header_button ml-4",
                onClick: _ctx.goOut
              }, {
                default: _withCtx(() => [
                  _hoisted_19
                ]),
                _: 1
              }, 8, ["onClick"])
            ])
          ]))
    ], 4),
    _hoisted_20
  ], 64))
}